import { CurrencyFormat } from 'common/src/modules/rnpl-common/pipes/currency-format/currency-format.pipe';

const currencyFormat = new CurrencyFormat();

/**
 * Strings to match a client-side search query against for an amount that comes from the backend
 * as a plain decimal (e.g. `3584.88`): the raw value, the format the UI shows it in
 * (`currencyFormat:'':2:'.':',':3:true` → `3.584,88`), and the same number without thousands
 * separators with either decimal delimiter (`3584,88`, `3584.88`).
 */
export function getAmountSearchVariants(amount: string | number): string[] {
  if (amount === null || amount === undefined || amount === '') { return []; }
  const displayed = currencyFormat.transform(amount, '', 2, '.', ',', 3, true);
  const plain = currencyFormat.transform(amount, '', 2, '', ',', 3, true);
  return [String(amount), displayed, plain, plain.replace(',', '.')];
}
